export const headerHeight = { xs: 104, md: 76 };
export const sidebarWidth = 260;
export const toolbarSx = { height: headerHeight, minHeight: headerHeight, flexShrink: 0 };
